export default __webpack_public_path__ + "static/media/commercial.8ed1fe06.jpg";